// The fiat-wallet activity feed unifies the ledger + in-flight recharge,
// withdraw, and rental-payout requests behind one endpoint. DETAIL returns a
// single movement with its per-leg slice (investmentDetails, depositDetails …).
export const TRANSACTION_ENDPOINTS = {
  LIST: '/api/wallets/fiat/activity',
  DETAIL: (id: string) => `/api/wallets/fiat/activity/${encodeURIComponent(id)}`,
  FILTERS: '/api/wallets/fiat/activity/filters',
} as const
